export const formatToK = (num: number): string => {
  if (num < 1000) {
    return num.toString();
  }

  const formatted = (num / 1000).toFixed(2);
  // Remove trailing zeros after decimal
  const cleaned = formatted.replace(/\.?0+$/, "");

  return `${cleaned}K`;
};

export const formatTime = (tInSec: number) => {
  const minutes = Math.floor(tInSec / 60); // Get total minutes
  const seconds = tInSec % 60; // Get remaining seconds
  // Format minutes and seconds to always show 2 digits (e.g., 02:05)
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0"
  )}`;
};

export const formatCamelCase = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getTimestamp = (dateStr: string) => {
  return new Date(dateStr).getTime();
};
